import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

import Site from 'stores/Site'

export default class Table {
    constructor(el) {
        gsap.registerPlugin(ScrollTrigger)

        const head = el.querySelector('.table-row-head')
        const last = el.querySelector('.table-row:last-child')

        ScrollTrigger.create({
            trigger: el,
            start: () => {
                return `top-=${Site.header.offsetHeight} top`
            },
            end: () => {
                return `bottom-=${Site.header.offsetHeight + head.offsetHeight + last.offsetHeight + 16} top`
            },
            pin: head,
            pinSpacing: false,
        })
    }
}